import React from 'react';

import styles from './Experience.module.scss';

const Experience = (props) => (
  <div className={styles.Experience} id="experience">
    <h2 className="h2">{props.title}</h2>
    <div className={styles.Experience__steps}>
      {props.steps.map((step, i) =>
        <div className={styles.Step} key={i}>
          { i === 0 && <img src="/images/experience-one.svg" alt="experience steps" /> }
          { i === 1 && <img src="/images/experience-two.svg" alt="experience steps" /> }
          { i === 2 && <img src="/images/experience-three.svg" alt="experience steps" /> }
          <p className={styles.Step__date}>{step.timeframe}</p>
          <h3 className="h3">{step.title}</h3>
          <p className="p-large">{step.details.details}</p>
        </div>
      )}
    </div>
  </div>
)

export default Experience;



// WEBPACK FOOTER //
// ./src/components/Program/Experience/index.js